module.exports = __webpack_public_path__ + "static/media/1.1696b450.jpg";